<script>
    import { onMount } from 'svelte';
    import { db, functions } from './stores.js';
    export let eventId = '';
    let conversationId;
    let loggedIn = false;
    let mode = "chat";
    let username = '';
    let client;
    let conversation;
    let message;
    let status = "sign-in";
    let errorStatus = "";
    let messages;
    let questions = new Map();

    onMount (async()=>{
       console.log('eventId: ', eventId);
       // Get conversation if it exists, if not create one
       $db.collection('broadcasts').doc(eventId).get()
        .then(function(doc) {
            if (doc.exists) {
                console.log("Broadcast details: ", doc.data());
                if (doc.data().conversationId){
                    conversationId = doc.data().conversationId;
                    console.log('got the conversationId: ',conversationId);
                } else {
                    console.log('no conversationid so make one!');
                    const createConversation = $functions.httpsCallable('createConversation');
                    createConversation({eventId: eventId}).then(function(result) {
                        console.log("result from createConversation: ",result);
                        conversationId = result.data.conversationId;
                        console.log('got the conversationId: ',conversationId);
                    }).catch(function(error){
                        console.log('error creatting conversationId: ',error);
                    });
                }
            }
        })
        .catch(function(error) {
            console.log("Error getting conversation ID: ", error);
        });
    });

    const postData = async(url='', data={}) => {
        console.log('data: ',data);
        status =  "logging-in";
        const response = await fetch(url, {
            method: 'POST',
            // mode: 'no-cors',
            // cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const responseJWT = await response.json();
        // console.log('events: ',events);
        // const events = JSON.parse(response);
		if (response.status === 200) {
            console.log('responseJWT: ',responseJWT);
			return responseJWT;
		} else {
			this.error(response.status, events.error);
		}

        // console.log('response: ', response);
        // return await response.json();
    };

    const loadIntialMessages = async() => {
        const messagesPage = await conversation.getEvents({ event_type: "message", page_size: 10, order: "desc" });
        // old way
        // const messagesPage = await conversation.getEvents({ event_type: "text", page_size: 10, order: "desc" });
        const questionsPage = await conversation.getEvents({ event_type: "custom:question", page_size: 10, order: "desc" });
        // messages = Array.from(messagesPage.items);
        // questions = Array.from(questionsPage.items);
        // messages = Object.entries(messagesPage.items);
        // questions = Object.entries(questionsPage.items);
        // console.log('initial messages: ', messagesPage);
        // console.log('initial questions: ', questionsPage);
        // messages = messagesPage.items;
        messages = new Map([...messagesPage.items.entries()].sort());
        questions = new Map([...questionsPage.items.entries()].sort());
        console.log('initial messages: ', messages);
        console.log('initial questions: ', questions);
    }

    const login = async() => {
        if(username){
            try {
                const data = await postData('https://us-central1-otech-events.cloudfunctions.net/getJWT', {eventId, "display_name": username, conversationId})
                console.log("data: ", data)
                // let app = await client.login(data.jwt);
                let app = await client.createSession(data.jwt);
                conversation = await app.getConversation(conversationId);
                console.log('conversation: ',conversation);
                //get early messages and questions if any;
                loadIntialMessages();
                //set up event listeners
                conversation.on('message', (sender, event)=>{
                    console.log('got text event!: ',sender, event);
                    //add event to messages
                    // messages = [...messages, ];
                    messages.set(event.id,event);
                    messages = messages;
                    console.log('messages on text: ',messages);
                });
                // old way
                // conversation.on('text', (sender, event)=>{
                //     console.log('got text event!: ',sender, event);
                //     //add event to messages
                //     // messages = [...messages, ];
                //     messages.set(event.id,event);
                //     messages = messages;
                //     console.log('messages on text: ',messages);
                // });
                conversation.on('question', (sender, event)=>{
                    console.log('got question event!: ',sender, event);
                    //add question to questions
                    // questions = [...questions, ]
                    questions.set(event.id,event);
                    questions = questions;
                    console.log('questions on custom event: ',questions);

                });

                loggedIn = true;
                status = 'logged-in';

            } catch (error) {
                console.error("Error getting JWT: ",error);
                errorStatus = error;
                status = 'sign-in';
            }
            // postData('https://us-central1-otech-events.cloudfunctions.net/getJWT', {eventId, "display_name": username, conversationId})
            // .then(data => {
            //     console.log(data)
            //     let app = await client.login(data.jwt);
            //     conversation = await app.getConversation(conversationId);
            //     console.log('conversation: ',conversation);
            //     loggedIn = true;
            // })
            // .catch(error => {
            //     console.error('Got an error: ',error);
            // });
        }
    };

    const submitMessage = async() => {
        console.log("submit message!");
        if (mode === 'chat'){
            //send text event
            console.log('send chat message:',message);
            try {
                await conversation.sendMessage({"message_type":"text", "text":message});
                // old way
                // await conversation.sendText(message);
                console.log('text event sent!');
                message = '';
            }
            catch(error){
                console.error('got an error sending a question: ', error);
                errorStatus = error;
            }

        } else if (mode === 'questions'){
            // send custom event questions
            console.log('send question:',message);
            try {
                await conversation.sendCustomEvent({ type: 'question', body: { question: message, username } });
                console.log('questionEvent sent!');
                message = '';
            }
            catch (error){
                console.error('got an error sending a question: ', error);
                errorStatus = error;
            }
        }
    }

    const initializeVonage = () => {
        console.log('initialize Vonage!');
        //********* Get a reference to NexmoClient **********
        const VonageClient = window.NexmoClient;
        client = new VonageClient({ debug: true});

        // console.log('VonageClient: ',VonageClient);


    }
</script>

<style>
    .selected {
		border-bottom: 2px red solid;
	}

	button {
		text-decoration: none;
        color: #000000;
        background: none;
        border-radius: 5px;
        padding: 5px;
        border: none;
        cursor: pointer;
	}

    #login {
        height: 100%;
        display: flex;
        align-items: center;
    }

    #chat-qs-container {
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    #tabs {
        display: flex;
        justify-content: space-around;
    }

    #messagesContainer {
        height: 100%;
        overflow-y: auto;
        /* display: flex;
        flex-direction: column-reverse; */
        /* flex-direction: column; */
        /* justify-content: flex-end; */
    }

    #chatContainer {
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column-reverse;
    }

    .bubble {
        margin: 10px 0 0;
        background: lightgray;
        border-radius: 10px 10px 10px 0;
        padding: 10px;
        width: auto;
    }
    .bubble.mine {
        border-radius: 10px 10px 0 10px;
    }
    .author {
        text-align: left;
    }

    .author.mine{
        text-align: right;
    }

</style>

<svelte:head>
    <!-- Load Vonage JS Client SDK from a CDN -->
    <script type="module" src="https://unpkg.com/nexmo-client@latest/dist/nexmoClient.js?module" on:load={initializeVonage}></script>
</svelte:head>

{#if status ===  'sign-in'}
    <section id="login">
        <form id="set-username" on:submit|preventDefault={login}>
            <label for="username">Enter chat username:</label>
            <input type="text" id="username" name="username" bind:value={username} required/>
            <br/><button type="submit">submit</button>
        </form>
        <div>{errorStatus}</div>
    </section>
{:else if status === 'logged-in'}
    <section id="chat-qs-container">
        <div id="tabs">
            <button class:selected="{mode === 'chat'}" on:click="{() => mode = 'chat'}">chat</button>
            <button class:selected="{mode === 'questions'}" on:click="{() => mode = 'questions'}">questions({questions.size})</button>    
        </div>
        <div id="messagesContainer">
            {#if mode === 'chat'}
                <div id="chatContainer">
                    <div id="chat">
                        {#if messages}
                            {#each [...messages] as [key,value]}
                                <div class="message" id={key}>
                                    <div class="bubble" class:mine="{value.from === conversation.me.id}">
                                        {value.body.text}
                                    </div>
                                    <div class="author" class:mine="{value.from === conversation.me.id}">
                                        {value._embedded.from_user.display_name}
                                        <!-- {conversation.members.get(value.from).display_name} -->
                                    </div>
                                </div>
                            {/each}
                        {/if}
                    </div>
                </div>
            {/if}
            {#if mode === 'questions'}
                {#if messages}
                    {#each [...questions] as [key,value]}
                        <div class="message" id={key}>
                            <div class="bubble" class:mine="{value.from === conversation.me.id}">
                                {value.body.question}
                            </div>
                            <div class="author" class:mine="{value.from === conversation.me.id}">
                                {value.body.username ? value.body.username : "Anon"}
                                <!-- {conversation.members.get(value.from).display_name} -->
                            </div>
                        </div>
                    {/each}
                {/if}

            {/if}
        </div>
        <form id="submit-message" on:submit|preventDefault={submitMessage}>
            <label for="message">Enter {mode==="chat"? 'message' : 'question'}</label>
            <input type="text" id="message" name="message" bind:value={message} required/>
            <button type="submit">send</button>
            <div>{errorStatus}</div>
        </form>
    </section>
{:else if status === "logging-in"}
    <p>Logging in</p>
{/if}

<!-- {#if loggedIn}
    <section id="chat-qs-container">
        <div id="tabs">
            <button class:selected="{mode === 'chat'}" on:click="{() => mode = 'chat'}">chat</button>
            <button class:selected="{mode === 'questions'}" on:click="{() => mode = 'questions'}">questions</button>    
        </div>
        <div id="messages">
            {#if mode === 'chat'}
                <h2>show chat</h2>
            {/if}
            {#if mode === 'questions'}
                <h2>show questions</h2>
            {/if}
        </div>
        <form id="submit-message" on:submit|preventDefault={submitMessage}>
            <label for="message">Enter {mode==="chat"? 'message' : 'question'}</label>
            <input type="text" id="message" name="message" bind:value={message} required/>
            <button type="submit">send</button>
        </form>
    </section>
{:else}
    {#if conversationId}
        <section id="login">
            <form id="set-username" on:submit|preventDefault={login}>
                <label for="username">Enter chat username:</label>
                <input type="text" id="username" name="username" bind:value={username} required/>
                <br/><button type="submit">submit</button>
            </form>
        </section>
    {/if}
{/if} -->